/* ----------------------------

Standalone Emergency Banner Script

---------------------------- */

/*
 Emergency banner functionality for use with headers that don't use the
 global-header-scripts.js file. (Ex: Slim Plus, Slim Shade E)
*/

/*
 Lightweight JSONP fetcher
 Copyright 2010-2019 Erik Arenhill. All rights reserved.
 BSD Zero Clause License
 https://github.com/erikarenhill/Lightweight-JSONP (modified)
*/
var ghJSONP=function(e){var t,n={};function o(e){return encodeURIComponent(e)}return{get:function(r,a,u,i){var c,d=-1===(r||"").indexOf("?")?"?":"&";i="getEmergency",a=a||{};for(c in a)a.hasOwnProperty(c)&&(d+=o(c)+"="+o(a[c])+"&");var l=!1;return e[i]=function(t){l||u(t);try{delete e[i]}catch(e){}e[i]=null},function(e,o){var r=document.createElement("script"),a=!1,u=null;r.src=e,r.async=!0;var i=n.error;function c(){clearTimeout(u),u=null}"function"==typeof i&&(r.onerror=function(t){c(),i({url:e,event:t})}),r.onload=r.onreadystatechange=function(){a||this.readyState&&"loaded"!==this.readyState&&"complete"!==this.readyState||(a=!0,c(),r.onload=r.onreadystatechange=null,r&&r.parentNode&&r.parentNode.removeChild(r))},n.timeout&&(u=setTimeout(function(){"function"==typeof i&&(i({url:e,event:new Error("Timeout")}),o())},n.timeout)),t||(t=document.getElementsByTagName("head")[0]),t.appendChild(r)}(r+d+"callback="+i,function(){l=!0}),i},init:function(e){n=e}}}(window);"undefined"!=typeof module&&(module.exports=ghJSONP);

$(document).ready(function(){
	
	// Emergency Banner
	var domain = window.location.host.split('.')[1];
	var localhost = (window.location.host == 'localhost' ? true : false);
	
	if (domain == 'elon' || localhost) { // only startup the emergency message loop if we're on elon.edu domain
		
		var subdomain = window.location.host.split('.')[0];
		var allowedSubdomains = 'www, webtest, webdev01';
		
		// only start emergency checks if we're on certain subdomains, too. For now, this is www, webtest and webdev01
		if (allowedSubdomains.indexOf(subdomain) >= 0 || localhost) { 
			ghSetupEmergencyBanner();
			setTimeout(ghCheckEmergencyBanner, 30000);
		}
		
	}	

});

// Setup emergency banner div, and fire emergency banner check
function ghSetupEmergencyBanner() {
	
	// Setup emergency banner
	var emergencyBanner = document.getElementById('emergency-banner');
	
	if (emergencyBanner == null) {
		
		var ghWrap = document.getElementById('headerArea');
		
		if (ghWrap != null) { // only run this on the new global header
			
			// Setup emergency-banner div
			var ghEB = document.createElement('div');
			ghEB.setAttribute('id', 'emergency-banner');
			
			// Check if next sibiling is main#mainArea and place banner appropriately
			var nextEle = ghWrap.nextElementSibling;
			
			if (nextEle.tagName == 'MAIN' && nextEle.id == 'mainArea') {
				nextEle.prepend(ghEB);
			} else {
				ghWrap.appendChild(ghEB);
			}	
			
			emergencyBanner = document.getElementById('emergency-banner');
			
		}
		
	}
	
	ghCheckEmergencyBanner();
	
}

// Check for updated emergency banner json file, update emergency banner div if necessary
function ghCheckEmergencyBanner() {

	var emergencyTest = ghQueryVariable('emergency_test');
	
	var emergencyUrl = (window.location.host === 'localhost')
    	? '//localhost/u/wp-content/json/emergency/emergency.jsonp'
    	: 'https://www.elon.edu/u/wp-content/json/emergency/emergency.jsonp';

	var emergencyBanner = document.getElementById('emergency-banner');
	var dt = new Date();
	var ticks = dt.getTime(); // used to prevent browser caching
	
	ghJSONP.get(emergencyUrl, {t: ticks}, function(response) {

		try {
			var isEnabled = response.enabled;
			var emergencyText = response.message;
			var emergencyColor = response.color;
			
			if (isEnabled == true) { // Check if the banner has been enabled by the admin
	
				if (emergencyText !== '' && emergencyText) {
					emergencyBanner.innerHTML = emergencyText;
					emergencyBanner.style.display = 'block';
					
					if (emergencyBanner.classList) {
						emergencyBanner.classList.add(emergencyColor);
					} else {
						emergencyBanner.className += ' ' + emergencyColor;
					}
					
				} else {
					emergencyBanner.innerHTML = '';
					emergencyBanner.style.display = 'none';
				}
				
			} else {
				
				if (emergencyTest == 1) {
					emergencyBanner.innerHTML = emergencyText;
					emergencyBanner.style.display = 'block';
					
					if (emergencyBanner.classList) {
						emergencyBanner.classList.add(emergencyColor);
					} else {
						emergencyBanner.className += ' ' + emergencyColor;
					}
					
				}
				
			}
		}
		catch(err) { }
		
	});
	
}

// Utility function for checking for URL query variables
function ghQueryVariable(variable) {
	var query = window.location.search.substring(1);
	var vars = query.split("&");
	for (var i=0;i<vars.length;i++) {
		var pair = vars[i].split("=");
		if(pair[0] == variable){return pair[1];}
	}
	return(false);
}